import { Image } from '~/components/Image';
import Typography from '~/components/Typography';
import useNewsletters from '~/hooks/useLoaders/useNewsletters';
import type { Publication } from '~/interfaces/publication';

import Section from './Section';
import SectionLoader from './SectionLoader';

interface Props {
  textColor: any;
  fontFamily: string;
  isNewWebBuilder?: boolean;
}

const NewslettersWidgetSection = ({ textColor, fontFamily, isNewWebBuilder = false }: Props) => {
  const { newsletters } = useNewsletters();

  return (
    <Section
      text="Newsletters"
      viewMoreLink="/publications"
      textColor={textColor}
      fontFamily={fontFamily}
      isNewWebBuilder={isNewWebBuilder}
    >
      {newsletters ? (
        <div className="space-y-2 pr-4">
          {newsletters.map((pub: Publication) => {
            return (
              <div key={pub.id} className="flex items-center space-x-2 truncate">
                <div>
                  <div className="h-6 w-6 overflow-hidden rounded border border-gray-300 bg-white">
                    <Image maxWidth={128} aspectRatio={'square'} src={pub.logo.url} alt={pub.name} />
                  </div>
                </div>

                <Typography
                  as="span"
                  color={textColor}
                  fontFamily={fontFamily}
                  fontFamilyv2={isNewWebBuilder ? fontFamily : undefined}
                  size="sm"
                  className="truncate font-medium"
                >
                  {pub.name}
                </Typography>
              </div>
            );
          })}
        </div>
      ) : (
        <SectionLoader />
      )}
    </Section>
  );
};

export default NewslettersWidgetSection;
